module.exports = __webpack_public_path__ + "resources/img/img_dataflow.66ca04aa6efd000b152943a4c288e5ce.png";